import { getConfig } from '@shared/library';
import '@shared/library/dist/styles/index.scss';
import '@shared/library/dist/styles/lib.scss';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import Optisewer from './components/Optisewer';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <BrowserRouter basename={getConfig("Optisewer", window.location, process.env).app.location}>
        <Optisewer />
    </BrowserRouter>
);